// -----------------------------------------------------------------------------
// Scripts for back to top button
// -----------------------------------------------------------------------------

$(function () {

  let scrollTop = $('#scrollUp');

  $(window).on('scroll', function () {

    var topPos = $(this).scrollTop();

    if (topPos > 200) {
      $(scrollTop).css('opacity', 1);
    } else {
      $(scrollTop).css('opacity', 0);
    }
  });
  $(window).trigger('scroll');


  $(scrollTop).on('click', function () {

    $('html, body').animate({
      scrollTop: 0
    }, 800);
    return false;

  });

});